/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  BadRequestErrorResponse,
  NotFoundErrorResponse,
  ResetPasswordEmailConfirmRequest,
  ResetPasswordRequest
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiResetPasswordCheckTokenResponse204 = {
  data: void
  status: 204
}

export type getApiResetPasswordCheckTokenResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiResetPasswordCheckTokenResponseSuccess = (getApiResetPasswordCheckTokenResponse204) & {
  headers: Headers;
};
export type getApiResetPasswordCheckTokenResponseError = (getApiResetPasswordCheckTokenResponse404) & {
  headers: Headers;
};

export type getApiResetPasswordCheckTokenResponse = (getApiResetPasswordCheckTokenResponseSuccess | getApiResetPasswordCheckTokenResponseError)

export const getGetApiResetPasswordCheckTokenUrl = (hash: string,) => {


  

  return `/api/reset-password/check-token/${hash}`
}

export const getApiResetPasswordCheckToken = async (hash: string, options?: RequestInit): Promise<getApiResetPasswordCheckTokenResponse> => {
  
  return customFetch<getApiResetPasswordCheckTokenResponse>(getGetApiResetPasswordCheckTokenUrl(hash),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiResetPasswordCompleteResponse204 = {
  data: void
  status: 204
}

export type postApiResetPasswordCompleteResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiResetPasswordCompleteResponseSuccess = (postApiResetPasswordCompleteResponse204) & {
  headers: Headers;
};
export type postApiResetPasswordCompleteResponseError = (postApiResetPasswordCompleteResponse404) & {
  headers: Headers;
};

export type postApiResetPasswordCompleteResponse = (postApiResetPasswordCompleteResponseSuccess | postApiResetPasswordCompleteResponseError)

export const getPostApiResetPasswordCompleteUrl = (hash: string,) => {


  

  return `/api/reset-password/complete/${hash}`
}

export const postApiResetPasswordComplete = async (hash: string,
    resetPasswordRequest: ResetPasswordRequest, options?: RequestInit): Promise<postApiResetPasswordCompleteResponse> => {
  
  return customFetch<postApiResetPasswordCompleteResponse>(getPostApiResetPasswordCompleteUrl(hash),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      resetPasswordRequest,)
  }
);}


export type postApiResetPasswordStartResponse204 = {
  data: void
  status: 204
}

export type postApiResetPasswordStartResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}
    
export type postApiResetPasswordStartResponseSuccess = (postApiResetPasswordStartResponse204) & {
  headers: Headers;
};
export type postApiResetPasswordStartResponseError = (postApiResetPasswordStartResponse400) & {
  headers: Headers;
};

export type postApiResetPasswordStartResponse = (postApiResetPasswordStartResponseSuccess | postApiResetPasswordStartResponseError)

export const getPostApiResetPasswordStartUrl = () => {


  

  return `/api/reset-password/start`
}

export const postApiResetPasswordStart = async (resetPasswordEmailConfirmRequest: ResetPasswordEmailConfirmRequest, options?: RequestInit): Promise<postApiResetPasswordStartResponse> => {
  
  return customFetch<postApiResetPasswordStartResponse>(getPostApiResetPasswordStartUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      resetPasswordEmailConfirmRequest,)
  }
);}


